import imageDrop from "../extensions/image_drop.js"
import { promptImage } from "../../../prompt_file.js"
import linkConverter from "../extensions/link_converter"

const extended = {
  extensions: ["link_converter", "image_drop"],

  toolbarOptions() {
    return {
      container: [
        [{ font: [] }], // Font selector
        [{ size: ["small", false, "large", "huge"] }], // Font size selector
        [{ color: [] }, { background: [] }], // Font color and background highlight
        ["bold", "italic", "underline", "strike"], // B, I, U, S buttons
        [{ list: "ordered" }, { list: "bullet" }], // Numbered and bullet lists
        [{ align: [] }], // Text alignment
        [{ indent: "-1" }, { indent: "+1" }], // Indent controls
        ["clean"],
        ["link", { custom_attach: "0" }, { image: "0" }],
      ],
      handlers: {
        // handlers object will be merged with default handlers object
        custom_attach: (_value) => this.attach(),
        image: (_value) => this.inline(),
      },
    }
  },

  attach() {
    this.hiddenInput.form.querySelector('input[type="file"]').click()
  },

  async inline() {
    const file = await promptImage()
    if (!file) return
    const module = this.getModules().imageDropAndPaste
    await module.insertImage(file)
  },
}

export default Object.assign({}, extended, linkConverter, imageDrop)
